import PropTypes from "prop-types";
import "./casino-customer-fieldset.scss";
import { FormattedMessage } from "react-intl";
import { PASSENGER_TYPE, PAYMENT_METHODS } from "app/constants";
import InputFormik from "app/pages/.shared/form/InputFormik";
import { paymentTypesValues } from "app/utils/propTypes";
import DateSelectorInputFormik from "app/pages/.shared/DateSelector/DateSelectorInputFormik";

const CasinoCustomerFieldset = ({ showMaidenName = false, selectedPaymentType }) => {
	return (
		<div className="casino-customer-fieldset">
			<div className="casino-customer-fieldset__title">
				<FormattedMessage id="payment.customer.title" />
			</div>

			{showMaidenName && (
				<div className="casino-customer-fieldset__maiden">
					<InputFormik
						label={<FormattedMessage id="casino.maiden.name.label" />}
						id="casino-maiden-name"
						name={
							selectedPaymentType === PAYMENT_METHODS.BCMC
								? "payment.cardBCMC.maidenName"
								: "payment.card.maidenName"
						}
					/>
				</div>
			)}

			<div className="casino-customer-fieldset__zipcode">
				<InputFormik
					type="number"
					id="casino-zipcode"
					name={
						selectedPaymentType === PAYMENT_METHODS.BCMC
							? "payment.cardBCMC.zipCodeOfBirth"
							: "payment.card.zipCodeOfBirth"
					}
					label={<FormattedMessage id="casino.zipcode.label" />}
					note={<FormattedMessage id="casino.zipcode.note" />}
				/>
			</div>
			<div className="casino-customer-fieldset__birthdate">
				<DateSelectorInputFormik
					isChildrenAgeRequired={true}
					formatMonth="2-digit"
					label={<FormattedMessage id="casino.birthdate.label" />}
					id="casino-birthdate"
					name={
						selectedPaymentType === PAYMENT_METHODS.BCMC
							? "payment.cardBCMC.birthdate"
							: "payment.card.birthdate"
					}
					type={PASSENGER_TYPE.ADULT}
				/>
			</div>
		</div>
	);
};

CasinoCustomerFieldset.propTypes = {
	showMaidenName: PropTypes.bool,
	selectedPaymentType: paymentTypesValues,
};

export default CasinoCustomerFieldset;
